import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["termPaymentDetails", "selected", "selectedLenderId", "selectedDownPaymentId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { defaultMemoize } from 'reselect';
import { produce } from 'immer';
import _setWith from 'lodash/setWith';
import _head from 'lodash/head';
import _set from 'lodash/set';
import _get from 'lodash/get';
import _toNumber from 'lodash/toNumber';
import _isEmpty from 'lodash/isEmpty';
import _values from 'lodash/values';
import _flattenDeep from 'lodash/flattenDeep';
import _some from 'lodash/some';
import _castArray from 'lodash/castArray';
import _isNil from 'lodash/isNil';
import _omit from 'lodash/omit';
import _unset from 'lodash/unset';
import _merge from 'lodash/merge';
import _toString from 'lodash/toString';
import _compact from 'lodash/compact';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _lowerCase from 'lodash/lowerCase';
import _filter from 'lodash/filter';
import _join from 'lodash/join';
import _forEach from 'lodash/forEach';
import _reduce from 'lodash/reduce';
import _concat from 'lodash/concat';
import _split from 'lodash/split';
import _pick from 'lodash/pick';
import _noop from 'lodash/noop';
import _isEqual from 'lodash/isEqual';
import _slice from 'lodash/slice';
import { EMPTY_OBJECT, EMPTY_ARRAY, EMPTY_STRING } from '../../app.constants';
import { APR_MF_DECIDER, formatValueBasedOnRateType } from '../../constants/retail/marketScan';
import Money from '../../utils/money';
import { MSStates, STATE_BY_MARKET_IDS, MSStateID } from '../constants/marketScan.constants';
import { CATEGORY_1_DEAL_TYPES, CATEGORY_2_DEAL_TYPES, CATEGORY_3_DEAL_TYPES, CATEGORY_4_DEAL_TYPES } from '../constants/startDeal.constants';
import { getAbsoluteDifferenceAsDays, toMoment, addDays, getUnix, DATE_TIME_FORMATS, getMomentValueOf } from '../../utils/dateUtils';
import { getTaxableFlagForCustomFeeForLease } from './markteScan.util';
import { VIN_LOOKUP, NEGATIVE_TRADE_PAYOFFS, LEASE_WORKING_CASH, STOCK_TYPE, PAYMENT_TYPE, MODELS, MAKES, VEHICLE_STATUS, DEALER_CERTIFIED, DEAL_TYPE, BODY_CLASS, VEHICLE_TYPE } from '../constants/constants';
import { REBATE_TYPES, RECEIPIENT_TYPE_TO_REBATE_TYPE } from '../../constants/retail/rebate.constants';
import { getNumber, getRandomId, findArrayItem, removeZeroAmount, arrayFilter, removeMatchedItems, formatCurrencyWithMoneyFormat, getLenderCodeName, isCreatedBySystem } from '.';
import { FEE_OVERRIDES, GROSS_TYPES, GROSS_CATEGORY, FEES_STATUS, LEASE_CONTRACT_FEES, MS_FEES, PAYMENT_TYPE_DOWNPAYMENT_TYPE_MAPPING, DOWN_PAYMENT_TYPES, DESKING_DISPLAY_NAME_FIELD_TYPES, SOURCES_OF_FEES, RESERVE_METHOD, RATE_TYPE_FACTOR, DEFAULT_REGION_ID, DEFAULT_PAYMENT_TYPE_FILTER, FIRST_MONTH_WAIVER, FIRST_MONTH_WAIVER_ID, PAYMENT_FREQUENCY as PAYMENT_FREQUENCY_MAP, TAX_AND_ZIP_CODE_DETAILS_VS_KEY, PAYMENT_TYPE_VS_TAX_TYPE, DEFAULT_SECURITY_DEPOSIT_OPTION, DEPOSIT_TYPE_VS_LABEL, PAYMENT_TYPES } from '../constants/desking.constants';
import { INTERNAL_FEE_CODES, CUSTOM_FEE_IDS } from '../../constants/retail/fee.constants';
import { REBATE_PAYMENT_TYPE_CODES } from '../constants/pages';
import * as DealReader from '../readers/deal.reader';
import { getGLBalanace, getVehicleType, getYMM, getBodyClass } from '../readers/vehicle.reader';
import { FEE_TYPES_MAP_API, REGISTRATION_FEE } from '../constants/feeUpdateTable.constants';
import * as ColumnDataReader from '../readers/columnData.reader';
import { getPaymentTypeCodeForDeal, getValidRebatesForColumn } from './rebateModalContent.utils';
import { PAYMENT_MODES } from '../constants/dealDetails.constants';
import { isLoanOrBalloonPaymentType, isLeasePaymentType } from '../helpers/desking.helpers';
import { getCashDeficiencyAccessoryAmount } from '../readers/accessoriesUpdate.reader';
import { getDefaultStateFeeTaxOptions as getLocalDefaultStateFeeTaxOptions } from '../StateFeeTax/MSStateFeeTax.config';
import { DEAL_STATUS, DEAL_STATUS_WEIGHTS } from '../constants/deal.constants';
import { getDealerMarketId, isPrecloseFlowEnabled } from '../readers/salesSetup.reader';
import { targetingParamRulesvalidatorFunction as lenderRulesvalidatorFunction, targetingsRulesValidatorParams as lenderRulesValidatorParams } from './targetingParamSelctor';
import { getCustomerAddressDetails, getMarketId, getAddressOfBuyerInDeal } from '../readers/customer.reader';
var USE_TRADE_IN_FOR_CCR = LEASE_WORKING_CASH.USE_TRADE_IN_FOR_CCR,
    USE_REBATES_IN_FOR_CCR = LEASE_WORKING_CASH.USE_REBATES_IN_FOR_CCR,
    USE_DOWNPAYMENT_FOR_CCR = LEASE_WORKING_CASH.USE_DOWNPAYMENT_FOR_CCR,
    CASH_ALWAYS_COVERS_DRIVEOFF = LEASE_WORKING_CASH.CASH_ALWAYS_COVERS_DRIVEOFF;
var EXCESS_DOWNPAYMENT = NEGATIVE_TRADE_PAYOFFS.EXCESS_DOWNPAYMENT,
    EXCESS_REBATES = NEGATIVE_TRADE_PAYOFFS.EXCESS_REBATES;
var BANK_OR_ACQUISITION_FEE = INTERNAL_FEE_CODES.BANK_OR_ACQUISITION_FEE,
    REGISTRATION_CHARGES = INTERNAL_FEE_CODES.REGISTRATION_CHARGES,
    LICENSE_FEE = INTERNAL_FEE_CODES.LICENSE_FEE;
var LENDER = DESKING_DISPLAY_NAME_FIELD_TYPES.LENDER,
    APR_MONEYFACTOR = DESKING_DISPLAY_NAME_FIELD_TYPES.APR_MONEYFACTOR,
    RESIDUAL = DESKING_DISPLAY_NAME_FIELD_TYPES.RESIDUAL,
    YEARLY_MILES = DESKING_DISPLAY_NAME_FIELD_TYPES.YEARLY_MILES,
    REBATE = DESKING_DISPLAY_NAME_FIELD_TYPES.REBATE,
    DUEBILLS = DESKING_DISPLAY_NAME_FIELD_TYPES.DUEBILLS,
    FNIMENU = DESKING_DISPLAY_NAME_FIELD_TYPES.FNIMENU,
    DAYS_TO_FIRSTPAYMENT = DESKING_DISPLAY_NAME_FIELD_TYPES.DAYS_TO_FIRSTPAYMENT,
    FEES = DESKING_DISPLAY_NAME_FIELD_TYPES.FEES,
    SECURITY_DEPOSIT = DESKING_DISPLAY_NAME_FIELD_TYPES.SECURITY_DEPOSIT,
    PAYMENT_FREQUENCY = DESKING_DISPLAY_NAME_FIELD_TYPES.PAYMENT_FREQUENCY,
    FINANCE_ADJUSTED_CAPITAL_COST = DESKING_DISPLAY_NAME_FIELD_TYPES.FINANCE_ADJUSTED_CAPITAL_COST,
    LOAN_TO_VALUE_RATIO = DESKING_DISPLAY_NAME_FIELD_TYPES.LOAN_TO_VALUE_RATIO,
    TAXES = DESKING_DISPLAY_NAME_FIELD_TYPES.TAXES,
    DRIVE_OFF = DESKING_DISPLAY_NAME_FIELD_TYPES.DRIVE_OFF,
    OUT_OF_POCKET_CASH = DESKING_DISPLAY_NAME_FIELD_TYPES.OUT_OF_POCKET_CASH,
    FINANCE_CHARGE = DESKING_DISPLAY_NAME_FIELD_TYPES.FINANCE_CHARGE; // const REBATE_ID = 'ID';

export function formatDeskingDetailsForServer(deskingPaymentDetails, deferredPayments, allLenders, allDownPayments, isMultipleDownpaymentEnabled) {
  return deskingPaymentDetails.map(function (_ref) {
    var termPaymentDetails = _ref.termPaymentDetails,
        selected = _ref.selected,
        selectedLenderId = _ref.selectedLenderId,
        selectedDownPaymentId = _ref.selectedDownPaymentId,
        restProps = _objectWithoutProperties(_ref, _excluded);

    var paymentType = _get(restProps, ['paymentOption', 'paymentType']);

    var downPayments = getDownPaymentsForPaymentType(allDownPayments, paymentType, isMultipleDownpaymentEnabled);
    var applicableDeferredPayments = isLoanOrBalloonPaymentType(paymentType) ? deferredPayments : EMPTY_OBJECT;
    var selectedLender = getLenderCodeName(allLenders, selectedLenderId);
    return _objectSpread(_objectSpread({}, restProps), {}, {
      selectedLender: selectedLender,
      // as of this writing we are not using this key anywhere in UI. Just keeping it since backend needs it
      selectedLenderId: selectedLenderId,
      termPaymentDetails: formatTermPaymentDetailsForServer({
        termPaymentDetails: termPaymentDetails,
        selected: selected,
        selectedLenderId: selectedLenderId,
        selectedDownPaymentId: selectedDownPaymentId,
        deferredPayments: applicableDeferredPayments,
        downPayments: downPayments,
        allLenders: allLenders
      })
    });
  });
}
export function formatTermPaymentDetailsForServer(_ref2) {
  var termPaymentDetails = _ref2.termPaymentDetails,
      selected = _ref2.selected,
      selectedLenderId = _ref2.selectedLenderId,
      selectedDownPaymentId = _ref2.selectedDownPaymentId,
      deferredPayments = _ref2.deferredPayments,
      downPayments = _ref2.downPayments,
      allLenders = _ref2.allLenders;
  var termPaymentDetailsFormatted = [];
  Object.keys(termPaymentDetails || {}).forEach(function (lenderId) {
    if (selectedLenderId === lenderId) {
      var lenderCodeName = getLenderCodeName(allLenders, lenderId);
      Object.keys(termPaymentDetails[lenderId] || {}).forEach(function (downPaymentId) {
        var isProgramSelected = selected && Number(selectedDownPaymentId) === Number(downPaymentId);
        var downPayment = downPayments[downPaymentId];
        var deferredPaymentDataForDownPayment = _get(deferredPayments, [downPaymentId]) || EMPTY_OBJECT;
        var data = termPaymentDetails[lenderId][downPaymentId];
        termPaymentDetailsFormatted.push(_objectSpread(_objectSpread({}, data), {}, {
          downPayment: downPayment,
          selected: isProgramSelected,
          lender: lenderCodeName,
          lenderId: lenderId
        }, deferredPaymentDataForDownPayment));
      });
    }
  });
  return termPaymentDetailsFormatted;
}
export var updateFeesForOtherColumns = function updateFeesForOtherColumns(currentFees, newColumnFees) {
  return newColumnFees.map(function (nf, index) {
    if (currentFees[index]) return currentFees[index];
    return {
      name: '',
      amount: '',
      id: getRandomId(),
      feeType: nf.feeType,
      deleted: true,
      taxable: false
    };
  });
};
export var updateFNIsForOtherColumns = function updateFNIsForOtherColumns(currentFNIs, newFNIs) {
  return newFNIs.map(function (nf, index) {
    if (currentFNIs[index]) return currentFNIs[index];
    return _objectSpread(_objectSpread({}, nf), {}, {
      code: '',
      price: '',
      cost: '',
      terms: '',
      miles: '',
      deleted: true
    });
  });
};
export var deletedIdsMapping = function deletedIdsMapping(deskingpaymentDetails) {
  var deletedIds = {};
  deskingpaymentDetails.forEach(function (dpd, index) {
    var dealFees = dpd.dealFees;
    dealFees.forEach(function (fee) {
      if (fee.deleted) {
        if (deletedIds[index]) {
          deletedIds[index].push('deleted');
        } else {
          deletedIds[index] = ['deleted'];
        }
      } else if (deletedIds[index]) {
        deletedIds[index].push('notDeleted');
      } else {
        deletedIds[index] = ['notDeleted'];
      }
    });
  });
  return deletedIds;
};
export var filterRebates = function filterRebates(Rebates) {
  var filteredRebates = Rebates.filter(function (_ref3) {
    var Value = _ref3.Value;

    var rebateValue = _get(Value, 'Values[0].Value', 0);

    return rebateValue !== 0;
  });
  return filteredRebates;
};
export var transposeCompatibilities = function transposeCompatibilities(Compatibilities, selectedRebateIds) {
  var returnObj = {};
  if (Compatibilities.length === 0) return returnObj;
  selectedRebateIds.forEach(function (selectedRebateId) {
    var columnIds = [];
    Compatibilities.forEach(function (_ref4) {
      var CompatibilityList = _ref4.CompatibilityList,
          columnId = _ref4.RebateID;
      var isPresent = CompatibilityList.find(function (rebateId) {
        return _toString(rebateId) === _toString(selectedRebateId);
      });
      if (isPresent) columnIds.push(columnId);
    });
    returnObj = _objectSpread(_objectSpread({}, returnObj), {}, _defineProperty({}, selectedRebateId, columnIds));
  });
  return returnObj;
};
export var mapRebate = function mapRebate(apiRebate) {
  var rebateId = apiRebate.ID,
      NameDisplay = apiRebate.NameDisplay,
      programNumber = apiRebate.Number,
      programCode = apiRebate.IdentCode,
      Value = apiRebate.Value,
      Name = apiRebate.Name,
      Terms = apiRebate.Terms,
      ReceipientType = apiRebate.ReceipientType,
      ManualValueInputRequired = apiRebate.ManualValueInputRequired,
      certificateNumber = apiRebate.certificateNumber,
      manuallyEdited = apiRebate.manuallyEdited,
      rebateType = apiRebate.rebateType;
  var rebateAmount = _typeof(Value) === 'object' ? _get(Value, 'Values[0].Value', 0) : Value;
  if (Terms) rebateAmount = _get(Terms, '[0].Value.Values[0].Value', 0);
  return _defineProperty({
    name: NameDisplay || Name,
    NameDisplay: NameDisplay || Name,
    rebateId: rebateId,
    programCode: programCode,
    programNumber: programNumber,
    rebateAmount: rebateAmount,
    deleted: false,
    rebateType: rebateType || RECEIPIENT_TYPE_TO_REBATE_TYPE[ReceipientType] || REBATE_TYPES.REBATE,
    certificateNumber: certificateNumber,
    manuallyEdited: manuallyEdited,
    paymentTypeCode: getPaymentTypeCodeForDeal(apiRebate),

    /**
     * following fields are not saved in db:
     */
    ManualValueInputRequired: ManualValueInputRequired
  }, rebateId, rebateAmount || EMPTY_STRING);
};
export var mapMsRebatesToDealRebates = function mapMsRebatesToDealRebates(rebateData) {
  var msRebates = _get(rebateData, 'msRebates') || [];
  var msRebate = _get(rebateData, 'msRebate') || {};
  if (!_isEmpty(msRebate)) return mapRebate(msRebate);
  return msRebates.map(function (rebate) {
    return mapRebate(rebate);
  });
};
export var getColumnRebatesFromAllRebates = function getColumnRebatesFromAllRebates(allRebates, columnRebates) {
  var validColumnRebates = allRebates.map(function (rebate) {
    var supersetRebateId = rebate.rebateId;
    var validColumnRebate = columnRebates.find(function (_ref6) {
      var deleted = _ref6.deleted,
          columnRebateId = _ref6.rebateId;
      return !deleted && _toString(columnRebateId) === _toString(supersetRebateId);
    });
    if (!validColumnRebate) return _objectSpread(_objectSpread({}, rebate), {}, {
      rebateAmount: null
    });
    return validColumnRebate;
  });
  return validColumnRebates;
};
export function getRabatesExcludingDealerCash(rebates) {
  return (rebates || EMPTY_ARRAY).filter(function (_ref7) {
    var rebateType = _ref7.rebateType;
    return rebateType !== REBATE_TYPES.DEALER_CASH;
  });
}
export function getRebatesTotal(rebates) {
  return (rebates || EMPTY_ARRAY).reduce(function (acc, _ref8) {
    var rebateAmount = _ref8.rebateAmount;
    return Money.add(acc, rebateAmount);
  }, 0);
}
export var getColumnAccessoriesFromAllAccessories = function getColumnAccessoriesFromAllAccessories(allAccessories, columnAccessories) {
  return allAccessories.map(function (uA) {
    var matchedAccessory = columnAccessories.find(function (accessory) {
      return findUniqueAccessory(accessory, uA);
    });
    if (matchedAccessory) return matchedAccessory;
    return _objectSpread(_objectSpread({}, uA), {}, {
      price: 0
    });
  });
};
export function findUniqueAccessory() {
  var acc1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var acc2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return acc1.uniqueId === acc2.uniqueId;
}
export var getColumnFNIsFromAllFNIs = function getColumnFNIsFromAllFNIs(allFNIs, columnFNIs) {
  return allFNIs.map(function (uF) {
    var matchedFNI = columnFNIs.find(function (fni) {
      return findUniqueFNIItem(fni, uF);
    });
    if (matchedFNI) return matchedFNI;
    return _objectSpread(_objectSpread({}, uF), {}, {
      price: 0
    });
  });
};
export var getColumnFeeFromAllFee = function getColumnFeeFromAllFee(allFee, columnFee) {
  return allFee.map(function (fee) {
    return columnFee.find(function (f) {
      return findUniqueFeeItem(f, fee);
    }) || _objectSpread(_objectSpread({}, fee), {}, {
      amount: 0,
      taxable: false // upfront: false,

    });
  });
};
export function getFeeInfoFromSetupFeeForFeeCodes(_ref9) {
  var fees = _ref9.fees,
      feeCodesForColumn = _ref9.feeCodesForColumn;
  var newFees = fees.reduce(function (aggregatedFees, fee) {
    var feeCode = _get(fee, 'feeCode');

    if (feeCodesForColumn.includes(feeCode)) {
      aggregatedFees.push(fee);
    }

    return aggregatedFees;
  }, []);
  return newFees;
}
export function formatFNIsBasedOnPaymentType(_ref10) {
  var fnis = _ref10.fnis,
      fniCodesForPaymentTypes = _ref10.fniCodesForPaymentTypes,
      paymentType = _ref10.paymentType,
      onInit = _ref10.onInit;

  // onInit means first time, i.e taht is while setting dealer config data to deskinng
  if (!onInit) {
    return fnis;
  } // first time we have to set fnis by taking ccare of payment type in mind.


  var fniCodes = _flattenDeep(_get(fniCodesForPaymentTypes, paymentType) || EMPTY_ARRAY);

  var ids = {};
  var newFNIs = [];
  fniCodes.forEach(function (lc) {
    ids[lc] = true;
  });
  fnis.forEach(function (fni) {
    var fniAttributeId = _get(fni, 'fnIAttributeId');

    if (ids[fniAttributeId]) {
      newFNIs.push(fni);
    }
  });
  return newFNIs;
}
export function formatFeeSearchToDealFees(fees, dealerId) {
  var formattedFees = [];
  fees.forEach(function (fee) {
    var _overrides;

    var overrides = (_overrides = {}, _defineProperty(_overrides, FEE_OVERRIDES.EXCLUDE_TAX_CALCULATIONS, true), _defineProperty(_overrides, FEE_OVERRIDES.ALLOW_USER_OVERRIDE, true), _overrides);
    var detailEntries = _get(fee, 'data.detailEntries') || [];
    var matchedDealerEntry = findArrayItem(detailEntries, 'dealerId', dealerId) || {};

    var feeStatus = _get(matchedDealerEntry, 'feeStatus');

    if (feeStatus === FEES_STATUS.ACTIVE) {
      var feeCode = _get(fee, 'data.feeCode');

      var description = _get(fee, 'data.description') || '';
      var categories = _get(fee, 'data.categories') || [];

      var internalFeeCode = _get(fee, 'data.maskedFee');

      var upfront = _get(fee, 'data.upfront') || false;
      var taxUpFront = _get(fee, 'data.upfrontTax') || false;
      var overrideFlags = _get(matchedDealerEntry, ['overrideFlags']) || [];
      var taxConfigs = _get(matchedDealerEntry, ['taxConfigs']) || [];
      overrideFlags.forEach(function (overFlag) {
        var flag = overFlag.flag,
            enabled = overFlag.enabled;
        overrides[flag] = !enabled;
      });
      categories.forEach(function (category) {
        var _matchedDealerEntry$s, _dealFee;

        var dealFee = (_dealFee = {
          id: getRandomId(),
          feeType: category,
          name: description,
          amount: matchedDealerEntry.flatPrice,
          baseAmount: (_matchedDealerEntry$s = matchedDealerEntry.salePricingDetail) === null || _matchedDealerEntry$s === void 0 ? void 0 : _matchedDealerEntry$s.basePrice,
          pricingType: matchedDealerEntry.pricingType,
          upfront: upfront,
          taxUpFront: taxUpFront,
          deleted: false,
          feeCode: feeCode
        }, _defineProperty(_dealFee, FEE_OVERRIDES.ALLOW_USER_OVERRIDE, overrides[FEE_OVERRIDES.ALLOW_USER_OVERRIDE]), _defineProperty(_dealFee, FEE_OVERRIDES.EXCLUDE_TAX_CALCULATIONS, overrides[FEE_OVERRIDES.EXCLUDE_TAX_CALCULATIONS]), _defineProperty(_dealFee, "internalFeeCode", internalFeeCode), _defineProperty(_dealFee, "taxable", internalFeeCode === BANK_OR_ACQUISITION_FEE ? false : overrides[FEE_OVERRIDES.EXCLUDE_TAX_CALCULATIONS]), _defineProperty(_dealFee, "overriden", overrides[FEE_OVERRIDES.ALLOW_USER_OVERRIDE]), _defineProperty(_dealFee, "taxConfigs", taxConfigs), _dealFee);
        formattedFees.push(dealFee);
      });
    }
  });
  return _castArray(formattedFees);
}
export function getInternalFeeCode(fee) {
  var internalFeeCode = _get(fee, 'internalFeeCode');

  return internalFeeCode;
}
export function formatFeesFromLookToIds(fees) {
  var lookupIds = {};
  fees.forEach(function (fee) {
    // const internalFeeCode = getInternalFeeCode(fee);
    var id = _get(fee, 'id');

    var isThisFeeRegistrationFeeType = isFeeRegistrationFeeItem(fee); // registartion fee will be manually added for negative values

    if (isThisFeeRegistrationFeeType) {
      lookupIds[id] = _objectSpread(_objectSpread({}, fee), {}, {
        manuallyAdded: true,
        upfrontDisabled: false
      });
    } else {
      lookupIds[id] = fee;
    }
  });
  return lookupIds;
}
export var sumAmount = function sumAmount(sumArray) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'amount';
  return (sumArray || []).reduce(function (total, current) {
    return +Money.add(Number(total), Number(current[field] || 0));
  }, 0);
};
export function makeAllFeesUndeleted(fees) {
  return fees.map(function (fee) {
    return _objectSpread(_objectSpread({}, fee), {}, {
      deleted: false
    });
  });
}
export var getAccessoriesByGrossType = function getAccessoriesByGrossType(grossType, deskingpaymentDetails) {
  var selectedPaymentDetails = (deskingpaymentDetails || []).find(function (dpd) {
    return dpd.selected;
  });

  if (selectedPaymentDetails) {
    var selectedAccessory = selectedPaymentDetails.accessories || [];
    var accessoriesByType = selectedAccessory.filter(function (_ref11) {
      var profitType = _ref11.profitType;
      return profitType === grossType;
    });
    return accessoriesByType;
  }

  return [];
};
export var getCostAdjustMentByGrossType = function getCostAdjustMentByGrossType(profitType, deal) {
  var costAdjustments = DealReader.getCostAdjustmentsOfPrimaryVehicle(deal);
  return (costAdjustments || []).filter(function (_ref12) {
    var grossType = _ref12.grossType;
    return grossType === profitType;
  });
};
export var getAllWorkingCashStatus = defaultMemoize(function (negativeTradePayoffs, leaseWokingCashConfigs) {
  var RebateCanPayTrade = false;
  var TreatRebateAsCCR = false;
  var TreatTradeInAsCCR = false;
  var CashCanPayTrade = false; // both are for downpayment as CCR

  var CashDoesntCoverInceptionFee = false;
  var TreatCashAsCCR = false;
  negativeTradePayoffs.forEach(function (payOffs) {
    var payOfftype = payOffs.payOfftype,
        enabled = payOffs.enabled;

    if (payOfftype === EXCESS_DOWNPAYMENT) {
      CashCanPayTrade = enabled;
    }

    if (payOfftype === EXCESS_REBATES) {
      RebateCanPayTrade = enabled;
    }
  });
  leaseWokingCashConfigs.forEach(function (config) {
    var leaseWorkingCashType = config.leaseWorkingCashType,
        enabled = config.enabled;

    if (leaseWorkingCashType === USE_TRADE_IN_FOR_CCR) {
      TreatTradeInAsCCR = enabled;
    }

    if (leaseWorkingCashType === USE_REBATES_IN_FOR_CCR) {
      TreatRebateAsCCR = enabled;
    }

    if (leaseWorkingCashType === USE_DOWNPAYMENT_FOR_CCR) {
      TreatCashAsCCR = enabled;
    }

    if (leaseWorkingCashType === CASH_ALWAYS_COVERS_DRIVEOFF) {
      CashDoesntCoverInceptionFee = !enabled;
    }
  });
  return {
    RebateCanPayTrade: RebateCanPayTrade,
    TreatRebateAsCCR: TreatRebateAsCCR,
    TreatCashAsCCR: TreatCashAsCCR,
    TreatTradeInAsCCR: TreatTradeInAsCCR,
    CashDoesntCoverInceptionFee: CashDoesntCoverInceptionFee,
    CashCanPayTrade: CashCanPayTrade
  };
});
export var setdaysToFirstPayment = defaultMemoize(function (columnData, daysToFirstPayment) {
  var termPaymentDetails = _get(columnData, 'termPaymentDetails') || {};
  var allLenders = Object.keys(termPaymentDetails);
  allLenders.forEach(function (lender) {
    var allDownPayments = Object.keys(_get(termPaymentDetails, [lender]) || {});
    allDownPayments.forEach(function (downPayment) {
      _set(termPaymentDetails, [lender, downPayment, 'daysToFirstPayment'], daysToFirstPayment);
    });
  });
});
export var getSelectedLenderDetails = defaultMemoize(function (lenders, selectedLenderId) {
  return (lenders || []).find(function (lender) {
    return lender.id === selectedLenderId;
  });
}) || {};
export var getGrossBreakup = function getGrossBreakup(deal, columnData) {
  var _grossData;

  var grossData = (_grossData = {}, _defineProperty(_grossData, GROSS_TYPES.FRONT, {}), _defineProperty(_grossData, GROSS_TYPES.BACK, {}), _grossData);

  function addGross(category, grossType, grossGetter) {
    for (var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      params[_key - 3] = arguments[_key];
    }

    var gross = grossGetter.apply(void 0, params);
    var totalSales = gross.totalSales,
        totalCost = gross.totalCost,
        totalDealerGross = gross.totalDealerGross;

    _set(grossData, [grossType, 'totalSales'], Money.add(grossData[grossType].totalSales, totalSales));

    _set(grossData, [grossType, 'totalCost'], Money.add(grossData[grossType].totalCost, totalCost));

    _set(grossData, [grossType, 'totalDealerGross'], Money.add(grossData[grossType].totalDealerGross, totalDealerGross));

    _set(grossData, [grossType, 'breakUp', category], gross);
  } // Front Grosses


  addGross(GROSS_CATEGORY.VEHCILE_SALE, GROSS_TYPES.FRONT, getVehicleSaleGross, deal, columnData);
  addGross(GROSS_CATEGORY.TRADE_IN, GROSS_TYPES.FRONT, DealReader.getTradeInGross, deal);
  addGross(GROSS_CATEGORY.FRONT_COST_ADJUSTMENTS, GROSS_TYPES.FRONT, DealReader.getCostAdjustmentGross, deal, GROSS_TYPES.FRONT);
  addGross(GROSS_CATEGORY.FRONT_FNI_PRODUCTS, GROSS_TYPES.FRONT, ColumnDataReader.getFNIGross, columnData);
  addGross(GROSS_CATEGORY.FRONT_DUE_BILLS_OR_ACCESSORIES, GROSS_TYPES.FRONT, ColumnDataReader.getAccessoriesGross, columnData, GROSS_TYPES.FRONT);
  addGross(GROSS_CATEGORY.FRONT_CASH_DEFICIENCY, GROSS_TYPES.FRONT, ColumnDataReader.getCashDeficiencyGross, columnData);

  if (getAutoRollCashDeficiencyFlag(deal)) {
    addGross(GROSS_CATEGORY.CAPPED_INCEPTION_FEE, GROSS_TYPES.FRONT, ColumnDataReader.getCappedInceptionFee, columnData);
  }

  addGross(GROSS_CATEGORY.FRONT_DEALER_CASH, GROSS_TYPES.FRONT, ColumnDataReader.getDealCashGross, columnData); // Back Grosses

  addGross(GROSS_CATEGORY.FINANCE_RESERVES, GROSS_TYPES.BACK, ColumnDataReader.getFinanceReserveGross, columnData);
  addGross(GROSS_CATEGORY.ACQUISITION_FEE_MARKUP, GROSS_TYPES.BACK, ColumnDataReader.getAcquistionFeeGross, columnData, BANK_OR_ACQUISITION_FEE, 'markup');
  addGross(GROSS_CATEGORY.BACK_COST_ADJUSTMENTS, GROSS_TYPES.BACK, DealReader.getCostAdjustmentGross, deal, GROSS_TYPES.BACK);
  addGross(GROSS_CATEGORY.BACK_FNI_PRODUCTS, GROSS_TYPES.BACK, ColumnDataReader.getFNIGross, columnData, GROSS_TYPES.BACK);
  addGross(GROSS_CATEGORY.BACK_DUE_BILLS_OR_ACCESSORIES, GROSS_TYPES.BACK, ColumnDataReader.getAccessoriesGross, columnData, GROSS_TYPES.BACK);
  return grossData;
};
export var getAutoRollCashDeficiencyFlag = function getAutoRollCashDeficiencyFlag(deal) {
  var leaseWorkingCashConfigs = _get(deal, ['workingCashConfig', 'leaseWorkingCashConfigs']) || [];
  var autoRollSetting = leaseWorkingCashConfigs.find(function (obj) {
    return obj.leaseWorkingCashType === LEASE_WORKING_CASH.AUTO_ROLL_CASH_DEFICIENCY;
  }) || {};
  return autoRollSetting.enabled;
};
export var getVehicleSaleGross = function getVehicleSaleGross(deal, selectedColumn) {
  var sellingPrice = getSelectedSellingPrice(deal, selectedColumn) || 0; // const invoicePrice = getInvoicePriceOfPrimaryVehicle(deal) || 0;

  var primaryVehicle = DealReader.getPrimaryVehicle(deal);
  var glBalance = getGLBalanace(primaryVehicle);
  var dealerGross = Number(Money.subtract(sellingPrice, glBalance)) || 0;
  return {
    totalSales: sellingPrice,
    totalCost: glBalance,
    totalDealerGross: dealerGross
  };
};
export var getCostAdjustments = function getCostAdjustments(allCostAdjustments, defaultCostAdjustmentIds) {
  return (allCostAdjustments || []).filter(function (costAdjustment) {
    var matchedCostAdjustment = defaultCostAdjustmentIds.find(function (adjustmentId) {
      return adjustmentId === costAdjustment.id;
    });
    return !!matchedCostAdjustment;
  });
};

var checkDealConditionsWithTargetParam = function checkDealConditionsWithTargetParam(_ref13) {
  var stockType = _ref13.stockType,
      dealType = _ref13.dealType,
      lenderType = _ref13.lenderType,
      oemCertified = _ref13.oemCertified,
      dealerCertified = _ref13.dealerCertified,
      make = _ref13.make,
      targetingParams = _ref13.targetingParams;
  var flag = true;

  _forEach(targetingParams, function (condition) {
    if (condition.attribute === 'STOCK_TYPE') flag = flag && condition.values.includes(stockType);else if (condition.attribute === 'DEAL_TYPE') flag = flag && condition.values.includes(dealType);else if (condition.attribute === 'LENDER') flag = flag && condition.values.includes(lenderType);else if (condition.attribute === MAKES) flag = flag && condition.values.includes(_lowerCase(make));else if (stockType === 'USED' && condition.attribute === VEHICLE_STATUS) flag = flag && condition.values.includes(_toString(oemCertified));else if (stockType === 'USED' && condition.attribute === DEALER_CERTIFIED) flag = flag && condition.values.includes(_toString(dealerCertified));
  });

  return flag;
};

var checkDealSatifiesAllTargetParam = function checkDealSatifiesAllTargetParam() {
  var targetingParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var deal = arguments.length > 1 ? arguments[1] : undefined;
  var columnData = arguments.length > 2 ? arguments[2] : undefined;
  var flag = true;
  targetingParams.forEach(function (condition) {
    var values = _get(condition, 'values') || EMPTY_ARRAY;

    switch (condition.attribute) {
      case STOCK_TYPE:
        {
          var primaryVehicle = DealReader.getPrimaryVehicle(deal);
          var stockType = getVehicleType(primaryVehicle);
          flag = flag && values.includes(stockType);
          break;
        }

      case PAYMENT_TYPE:
        {
          var paymentType = ColumnDataReader.getPaymentType(columnData);
          flag = flag && values.includes(paymentType);
          break;
        }

      case MAKES:
        {
          var _primaryVehicle = DealReader.getPrimaryVehicle(deal);

          var _getYMM = getYMM(_primaryVehicle),
              make = _getYMM.make;

          var makeInLowerCase = _lowerCase(make);

          flag = flag && values.includes(makeInLowerCase);
          break;
        }

      case DEAL_TYPE:
        {
          var dealType = DealReader.getDealType(deal);
          flag = flag && values.includes(dealType);
          break;
        }

      case BODY_CLASS:
        {
          var _primaryVehicle2 = DealReader.getPrimaryVehicle(deal);

          var vehicleClass = getBodyClass(_primaryVehicle2);
          flag = flag && values.includes(vehicleClass);
          break;
        }

      case MODELS:
        {
          var _DealReader$getPrimar = DealReader.getPrimaryVehicle(deal),
              displayModel = _DealReader$getPrimar.displayModel;

          flag = flag && values.includes(displayModel);
          break;
        }

      default:
        {// Do nothing
        }
    }
  });
  return flag;
};

var getCostAdjFromId = function getCostAdjFromId(costAdjustmentIds, adjustmentList) {
  if (!_isEmpty(costAdjustmentIds)) {
    return _compact(costAdjustmentIds.map(function (costAdjustmentId) {
      var detailedDataFromSetup = adjustmentList.find(function (_ref14) {
        var id = _ref14.id;
        return costAdjustmentId === id;
      });

      if (_isEmpty(detailedDataFromSetup)) {
        return null;
      }

      return {
        id: _get(detailedDataFromSetup, 'id'),
        description: _get(detailedDataFromSetup, 'costName'),
        grossType: _get(detailedDataFromSetup, 'grossType'),
        amount: _get(detailedDataFromSetup, 'value'),
        reconditioning: _get(detailedDataFromSetup, 'reconditioning'),
        manuallyAdded: false
      };
    }));
  }

  return EMPTY_ARRAY;
};

export var getCostAdjustmentForDealVehicle = function getCostAdjustmentForDealVehicle(_ref15) {
  var stockType = _ref15.stockType,
      dealType = _ref15.dealType,
      lenderType = _ref15.lenderType,
      oemCertified = _ref15.oemCertified,
      dealerCertified = _ref15.dealerCertified,
      defaultCostAdjustments = _ref15.defaultCostAdjustments,
      adjustmentList = _ref15.adjustmentList,
      make = _ref15.make;
  var finalCostAdjustmentIds = [];
  defaultCostAdjustments.forEach(function (costAdj) {
    var targetingParams = costAdj.targetingParams,
        costAdjustmentId = costAdj.costAdjustmentId;
    if (checkDealConditionsWithTargetParam({
      stockType: stockType,
      dealType: dealType,
      lenderType: lenderType,
      oemCertified: oemCertified,
      dealerCertified: dealerCertified,
      make: make,
      targetingParams: targetingParams
    })) finalCostAdjustmentIds.push(costAdjustmentId);
  });
  var finalCostAdjustments = getCostAdjFromId(_flattenDeep(finalCostAdjustmentIds), adjustmentList);
  return finalCostAdjustments;
};
export var getDueBillIdsForDeal = function getDueBillIdsForDeal(_ref16) {
  var _ref16$dueBills = _ref16.dueBills,
      dueBills = _ref16$dueBills === void 0 ? EMPTY_ARRAY : _ref16$dueBills,
      deal = _ref16.deal,
      columnData = _ref16.columnData;
  var finalDueBillsIds = new Set([]);
  dueBills.forEach(function (dueBill) {
    var dueBillIds = _get(dueBill, 'dueBillId') || EMPTY_ARRAY;
    var targetingParams = _get(dueBill, 'targetingParams') || EMPTY_ARRAY;

    if (checkDealSatifiesAllTargetParam(targetingParams, deal, columnData)) {
      dueBillIds.forEach(finalDueBillsIds.add, finalDueBillsIds);
    }
  });
  return _toConsumableArray(finalDueBillsIds);
};
export function formatAccessoriesBasedOnSetup(_ref17) {
  var accessories = _ref17.accessories,
      onInit = _ref17.onInit,
      dueBillSetupConfig = _ref17.dueBillSetupConfig,
      allDueBillById = _ref17.allDueBillById,
      columnData = _ref17.columnData,
      deal = _ref17.deal,
      keepManuallyUpdatedAccessories = _ref17.keepManuallyUpdatedAccessories;

  // onInit means first time, i.e taht is while setting dealer config data to deskinng
  if (!onInit) {
    return accessories;
  }

  var dueBillIds = getDueBillIdsForDeal({
    dueBills: dueBillSetupConfig,
    deal: deal,
    columnData: columnData
  });
  var newAccessories = dueBillIds.map(function (dueBillId) {
    return allDueBillById[dueBillId];
  });
  return _compact([].concat(_toConsumableArray(newAccessories), _toConsumableArray(keepManuallyUpdatedAccessories ? ColumnDataReader.getManuallyUpdatedColumnAccessories(columnData) : [])));
}
export var getFirstPaymentDate = function getFirstPaymentDate(columndata, deal) {
  return addDays(ColumnDataReader.getDaysToFirstPayment(columndata), _get(deal, 'soldTime') || getUnix());
};
export function getTermAsPerPaymentFrequency(columnData, deal) {
  var term = Number(ColumnDataReader.getTerm(columnData)); // months

  var start = getFirstPaymentDate(columnData, deal);
  var end = toMoment(start).add(term, 'months');
  var totalDays = getAbsoluteDifferenceAsDays(start, end);

  switch (ColumnDataReader.getPaymentFrequency(columnData)) {
    case PAYMENT_FREQUENCY_MAP.YEARLY:
      term /= 12;
      break;

    case PAYMENT_FREQUENCY_MAP.WEEKLY:
      term = Math.floor(totalDays / 7);
      break;

    case PAYMENT_FREQUENCY_MAP.BIWEEKLY:
      term = Math.floor(totalDays / 14);
      break;

    case PAYMENT_FREQUENCY_MAP.SEMI_MONTHLY:
      term = Math.floor(totalDays / 15);
      break;

    default: // PAYMENT_FREQUENCY_MAP.MONTHLY

  }

  return term;
}
export var getFirstPaymentIn = function getFirstPaymentIn(selectedPaymentDetails, deal) {
  var firstPaymentDuration = ColumnDataReader.getDaysToFirstPayment(selectedPaymentDetails);
  var firstPaymentDate = getFirstPaymentDate(selectedPaymentDetails, deal);
  var formattedDate = firstPaymentDate.format(DATE_TIME_FORMATS.DATE_ALPHA_MONTH);
  var firstPaymentIn = "".concat(formattedDate, " (").concat(firstPaymentDuration, " days)");
  return firstPaymentIn;
};
export function modifyDeferredPaymentsForNewDownPayment() {
  var deferredPayments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var downPayment = arguments.length > 1 ? arguments[1] : undefined;
  var deferredPayment1 = deferredPayments.deferredPayment1,
      deferredPayment2 = deferredPayments.deferredPayment2,
      deferredPayment3 = deferredPayments.deferredPayment3,
      deferredPayment4 = deferredPayments.deferredPayment4;
  var deferredPayment2Amount = _get(deferredPayment2, 'payment') || 0;
  var deferredPayment3Amount = _get(deferredPayment3, 'payment') || 0;
  var deferredPayment4Amount = _get(deferredPayment4, 'payment') || 0;
  var sumOfLast3DeferredPayments = Money.add(Money.add(deferredPayment2Amount, deferredPayment3Amount), deferredPayment4Amount);
  var requiredFirstDownPayment = Number(Money.subtract(downPayment, sumOfLast3DeferredPayments)) || 0;

  if (requiredFirstDownPayment < 0) {
    return {
      deferredPayment1: _objectSpread(_objectSpread({}, deferredPayment1), {}, {
        payment: downPayment
      })
    };
  }

  return _objectSpread(_objectSpread({}, deferredPayments), {}, {
    deferredPayment1: _objectSpread(_objectSpread({}, deferredPayment1), {}, {
      payment: requiredFirstDownPayment
    })
  });
}
export function getRebatesDisplayNames(rebates) {
  return rebates.map(function (_ref18) {
    var name = _ref18.name,
        value = _ref18.rebateAmount,
        rebateType = _ref18.rebateType;
    return {
      name: rebateType === REBATE_TYPES.DEALER_CASH ? "".concat(name, " ( Dealer Cash )") : name,
      value: value ? formatCurrencyWithMoneyFormat(value) : '-'
    };
  });
}
export function checkForMSFees(internalFeeCode) {
  return MS_FEES.includes(internalFeeCode);
}
export function findUniqueFeeItem() {
  var fee1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fee2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fee1.feeCode === fee2.feeCode; // return fee1.name === fee2.name || fee1.feeCode === fee2.feeCode;
}
export function findUniqueFNIItem() {
  var fni1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fni2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // now there can be products with no code
  // and there are no duplicates, so checking productId, providerId combo should work.
  var comboId1 = "".concat(fni1.productId).concat(fni1.providerId);
  var comboId2 = "".concat(fni2.productId).concat(fni2.providerId);
  return comboId1 === comboId2;
}
export function getUpdateMenuSum(array) {
  var total = array.reduce(function (acc, item) {
    var price = item.price;
    return Money.add(acc, _toNumber(price));
  }, 0);
  return total;
}
export function getUpdateFeesSum(fees) {
  var total = _reduce(fees, function (acc, item) {
    var amount = item.amount;
    return Money.add(acc, _toNumber(amount));
  }, 0);

  return total;
}
export function calculateTotalEMIAmountForDealerTrade(deal, columnData) {
  var netTradeINValue = DealReader.getNetTradeInValue(deal);
  var sellingPrice = getSelectedSellingPrice(deal, columnData);
  var columnAccessories = ColumnDataReader.getColumnAccessories(columnData);
  var accessoriesSum = getUpdateMenuSum(columnAccessories);
  var totalAmount = Money.add(accessoriesSum, Money.subtract(sellingPrice, netTradeINValue));
  return totalAmount;
}
export var formatLenderCodes = function formatLenderCodes(lenderCodes) {
  return lenderCodes.map(function (lenderCode) {
    var code = _get(lenderCode, 'code');

    var type = _get(lenderCode, 'type');

    return {
      Code: code,
      Type: type
    };
  });
};
export function isRegistrationItemFee(fee) {
  // these are the fees from RegistrationItem, as well as added from fee management
  var internalFeeCode = getInternalFeeCode(fee);

  var feeType = _get(fee, ['feeType']);

  var isDMVFee = feeType === FEE_TYPES_MAP_API.dmvFees;

  if (internalFeeCode === REGISTRATION_CHARGES || internalFeeCode === LICENSE_FEE || isDMVFee && internalFeeCode === INTERNAL_FEE_CODES.LIEN_FEE || isDMVFee && internalFeeCode === INTERNAL_FEE_CODES.TITLE_FEE) {
    return true;
  }

  return false;
}
export function isFeeRegistrationFeeItem(fee) {
  var internalFeeCode = getInternalFeeCode(fee);

  if (internalFeeCode === REGISTRATION_CHARGES || internalFeeCode === LICENSE_FEE) {
    return true;
  }

  return false;
}
export function changeCostInAccessories(accessories, uniqueId, newCost) {
  return accessories.map(function (acc) {
    if (acc.uniqueId === uniqueId) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        cost: newCost
      });
    }

    return acc;
  });
}
export function changeCostInFNis(fnis, id, newCost) {
  return fnis.map(function (fni) {
    if (fni.id === id) {
      return _objectSpread(_objectSpread({}, fni), {}, {
        cost: newCost
      });
    }

    return fni;
  });
} // columnData comes from draft(produce)

export var setRebatesInColumn = function setRebatesInColumn(columnData, rebates) {
  var newColumnData = columnData;
  var term = getNumber(ColumnDataReader.getTerm(columnData));
  var filteredRebates = getValidRebatesForColumn(_get(columnData, 'paymentOption.paymentType'), term, rebates);
  var termPaymentDetails = newColumnData.termPaymentDetails;
  Object.keys(termPaymentDetails).forEach(function (bankKey) {
    Object.keys(termPaymentDetails[bankKey]).forEach(function (downPaymentKey) {
      _set(newColumnData, ['termPaymentDetails', bankKey, downPaymentKey, 'rebates'], filteredRebates);
    });
  });
  return newColumnData;
};
export var mergeRebatesSupersetAndColumnRebates = function mergeRebatesSupersetAndColumnRebates(rebatesSuperset, columnData) {
  return _map(rebatesSuperset, function (rebate) {
    return _find(ColumnDataReader.getColumnRebates(columnData), function (_ref19) {
      var rebateId = _ref19.rebateId;
      return _toString(rebateId) === _toString(_get(rebate, 'rebateId'));
    }) || rebate;
  });
}; // columnData comes from draft(produce)
// can be used to modify firstPaymentWaived, firstPaymentWaivedAmount, firstPaymentWaiverManuallyOveridden in columnData

export var setFirstPaymentWaiverInColumn = function setFirstPaymentWaiverInColumn(columnData, value) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'firstPaymentWaivedAmount';
  var newColumnData = columnData;
  var termPaymentDetails = newColumnData.termPaymentDetails;
  Object.keys(termPaymentDetails).forEach(function (bankKey) {
    Object.keys(termPaymentDetails[bankKey]).forEach(function (downPaymentKey) {
      _set(newColumnData, ['termPaymentDetails', bankKey, downPaymentKey, key], value);
    });
  });
  return newColumnData;
};
export var getInitialWaiverRebate = function getInitialWaiverRebate(rebateAmount) {
  return {
    name: FIRST_MONTH_WAIVER,
    rebateId: FIRST_MONTH_WAIVER_ID,
    custom: true,
    rebateType: REBATE_TYPES.REBATE,
    deleted: false,
    createdTime: getMomentValueOf(),
    rebateAmount: rebateAmount,
    firstMonthWaiver: true,
    paymentTypeCode: REBATE_PAYMENT_TYPE_CODES.LEASE
  };
}; // columnData may come from draft(produce)

export var getColumnRebatesWithModifiedFirstWaiverAmt = function getColumnRebatesWithModifiedFirstWaiverAmt(columnData) {
  var selectedDownPaymentId = ColumnDataReader.getSelectedDownPaymentID(columnData);
  var firstPaymentWaived = ColumnDataReader.isFirstPaymentWaived(columnData, selectedDownPaymentId);
  var firstPaymentWaivedAmount = ColumnDataReader.getFirstPaymentWaivedAmount(columnData, selectedDownPaymentId);
  var columnRebates = ColumnDataReader.getColumnRebates(columnData);
  var index = columnRebates.findIndex(function (_ref20) {
    var firstMonthWaiver = _ref20.firstMonthWaiver;
    return firstMonthWaiver;
  }); // decide on fpw now

  if (firstPaymentWaived) {
    if (index === -1) {
      columnRebates = columnRebates.concat(_castArray(getInitialWaiverRebate(firstPaymentWaivedAmount)));
    } else {
      columnRebates = produce(columnRebates, function (draft) {
        _set(draft[index], 'rebateAmount', firstPaymentWaivedAmount);
      });
    }
  } else if (index !== -1) {
    // when it's added by rebate popup, we need to remove it
    columnRebates = columnRebates.filter(function (_ref21) {
      var firstMonthWaiver = _ref21.firstMonthWaiver;
      return !firstMonthWaiver;
    });
  }

  return columnRebates;
};
export function setFeesInColumn(columnData, dealFees, manuallyDeletedFees) {
  var termPaymentDetails = columnData.termPaymentDetails;
  Object.keys(termPaymentDetails).forEach(function (bankKey) {
    Object.keys(termPaymentDetails[bankKey]).forEach(function (downPaymentKey) {
      _set(columnData, ['termPaymentDetails', bankKey, downPaymentKey, 'dealFees'], dealFees);

      if (!_isNil(manuallyDeletedFees)) {
        _set(columnData, ['termPaymentDetails', bankKey, downPaymentKey, 'manuallyDeletedFees'], manuallyDeletedFees);
      }
    });
  });
  return columnData;
}
export function combineRegistrationFee(fees) {
  var feesWithCombinedRegFee = [];
  var registrationFeeItem = {
    feeType: FEE_TYPES_MAP_API.dmvFees,
    name: REGISTRATION_FEE,
    amount: 0,
    upfront: true,
    taxable: false,
    deleted: false,
    overriden: false,
    marketScanAmt: 0,
    id: getRandomId(),
    internalFeeCode: REGISTRATION_CHARGES,
    feeCode: REGISTRATION_CHARGES
  };
  fees.forEach(function (fee) {
    var internalFeeCode = getInternalFeeCode(fee);

    if (internalFeeCode !== REGISTRATION_CHARGES) {
      feesWithCombinedRegFee.push(fee);
    } else {
      var amount = _get(fee, 'amount') || 0;
      registrationFeeItem.amount = Money.add(registrationFeeItem.amount, getNumber(amount));
    }
  });
  feesWithCombinedRegFee.push(registrationFeeItem);
  return feesWithCombinedRegFee;
}
export function getFeesForPDFs(deskingPaymentDetails) {
  var selectedColumn = ColumnDataReader.getSelectedColumn(deskingPaymentDetails);
  var columnFees = ColumnDataReader.getColumnFees(selectedColumn);
  var requiredFees = removeFeesFromDealFees(columnFees, FEE_TYPES_MAP_API.leaseContractFees);
  var feesAfterCombiningRegFees = combineRegistrationFee(requiredFees);
  return removeZeroAmount(feesAfterCombiningRegFees);
}
export function removeMSFees(columnDealFees) {
  var customFees = columnDealFees.filter(function (fee) {
    var internalFeeCode = getInternalFeeCode(fee);

    if (!MS_FEES.includes(internalFeeCode)) {
      return true;
    }

    return false;
  });
  return customFees;
}
export function setDealFeesInColumn(newColumnData, columnDealFees) {
  var customFees = removeMSFees(columnDealFees);
  var termPaymentDetails = newColumnData.termPaymentDetails;
  Object.keys(termPaymentDetails).forEach(function (bankKey) {
    Object.keys(termPaymentDetails[bankKey]).forEach(function (downPaymentKey) {
      _set(newColumnData, ['termPaymentDetails', bankKey, downPaymentKey, 'dealFees'], customFees);
    });
  });
  return newColumnData;
}
export function checkForLeaseContractFees(internalFeeCode) {
  return LEASE_CONTRACT_FEES.includes(internalFeeCode);
}
export function removeFeesFromDealFees(fees, feeType) {
  return removeMatchedItems(fees, 'feeType', feeType);
}
export function formatFeesToMSPayloadCustomFee(fees, deal, leaseOrOnePayPaymentType, explicitelyTaxCappedCustomFeeInLease, taxAcquisitionFee) {
  var presentFees = arrayFilter(fees, 'deleted', false);
  var requiredFees = removeFeesFromDealFees(presentFees, FEE_TYPES_MAP_API.leaseContractFees);
  var msFormattedFees = requiredFees.map(function (vf, index) {
    var name = vf.name,
        _vf$amount = vf.amount,
        amount = _vf$amount === void 0 ? 0 : _vf$amount,
        taxable = vf.taxable,
        upfront = vf.upfront,
        _vf$marketScanAmt = vf.marketScanAmt,
        marketScanAmt = _vf$marketScanAmt === void 0 ? 0 : _vf$marketScanAmt,
        internalFeeCode = vf.internalFeeCode,
        taxUpFrontFromFee = vf.taxUpFront,
        feeType = vf.feeType;
    var overrideFees = DealReader.getOverrideFees(deal);
    var incap = leaseOrOnePayPaymentType ? !upfront : undefined;
    var taxInCapFee = leaseOrOnePayPaymentType ? !taxUpFrontFromFee : undefined; // const taxState = (upfront || loanOrCashPaymentType) ? taxable : false;

    var isFeeTaxable = internalFeeCode === BANK_OR_ACQUISITION_FEE ? taxAcquisitionFee : taxable;
    var taxState = leaseOrOnePayPaymentType ? getTaxableFlagForCustomFeeForLease(isFeeTaxable, upfront, explicitelyTaxCappedCustomFeeInLease) : taxable;
    var value = checkForMSFees(internalFeeCode) ? Number(Money.subtract(amount, marketScanAmt)) : amount;

    if (overrideFees && feeType === FEE_TYPES_MAP_API.dmvFees && checkForMSFees(internalFeeCode)) {
      value = amount;
    }

    return {
      Description: name,
      ID: CUSTOM_FEE_IDS[internalFeeCode] || index,
      Taxable: taxState,
      Value: value,
      Type: '',
      TaxInCap: taxInCapFee,
      InCap: incap,
      StrongType: 0
    };
  });
  return msFormattedFees;
}
export var getTotalFees = function getTotalFees(dealFees) {
  var totalFee = 0;
  dealFees.forEach(function (df) {
    var amount = df.amount;

    if (amount) {
      totalFee = Money.add(totalFee, amount);
    }
  });
  return totalFee;
};
export var getFnITotal = function getFnITotal(fnIs) {
  var totalFnI = 0;
  fnIs.forEach(function (fnI) {
    var price = fnI.price;

    if (price) {
      totalFnI = Money.add(totalFnI, price);
    }
  });
  return totalFnI;
};
export var getTotalRebate = function getTotalRebate(rebates) {
  var totalRebate = 0;
  rebates.forEach(function (rebate) {
    var rebateId = rebate.rebateId,
        rebateAmount = rebate.rebateAmount,
        deleted = rebate.deleted;

    if (!deleted) {
      if (rebateId && rebateAmount) {
        totalRebate = Money.add(totalRebate, rebateAmount);
      }
    }
  });
  return totalRebate;
};
export var getAccessoriesTotal = function getAccessoriesTotal(accessories) {
  var totalAccessories = 0;
  accessories.forEach(function (acc) {
    var price = acc.price;

    if (price) {
      totalAccessories = getNumber(Money.add(totalAccessories, price));
    }
  });
  return totalAccessories;
};
export var getDownPaymentsForPaymentType = function getDownPaymentsForPaymentType(allDownPayments, paymentType, isMultipleDownPaymentEnabled) {
  var downPaymentType = paymentType && isMultipleDownPaymentEnabled ? PAYMENT_TYPE_DOWNPAYMENT_TYPE_MAPPING[paymentType] : DOWN_PAYMENT_TYPES.LOAN_DOWNPAYMENTS;
  var downPaymentsToUse = allDownPayments.map(function (downPayment) {
    return downPayment[downPaymentType];
  });
  return downPaymentsToUse;
};
export var getDownPaymentsIds = function getDownPaymentsIds(allDownPayments) {
  return Object.keys(allDownPayments);
};
export var getDownPaymentObjectForAllTypes = function getDownPaymentObjectForAllTypes(downPayment) {
  var downPaymentObject = {};

  _values(DOWN_PAYMENT_TYPES).forEach(function (downPaymentType) {
    downPaymentObject[downPaymentType] = downPayment;
  });

  return downPaymentObject;
};
export var getDownPaymentsForAllDownPaymentTypes = function getDownPaymentsForAllDownPaymentTypes(downPayments) {
  var downPaymentsToUse = Array.isArray(downPayments) ? downPayments : [downPayments];
  var result = [];
  downPaymentsToUse.forEach(function (downPayment) {
    result.push(getDownPaymentObjectForAllTypes(downPayment));
  });
  return result;
};
export function getDealTypeFields(dealType) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$shouldInclud = options.shouldIncludeFees,
      shouldIncludeFees = _options$shouldInclud === void 0 ? false : _options$shouldInclud,
      _options$shouldInclud2 = options.shouldIncludeTaxes,
      shouldIncludeTaxes = _options$shouldInclud2 === void 0 ? false : _options$shouldInclud2;

  if (CATEGORY_1_DEAL_TYPES.includes(dealType)) {
    var _ref22;

    return _ref22 = {}, _defineProperty(_ref22, LENDER, LENDER), _defineProperty(_ref22, APR_MONEYFACTOR, APR_MONEYFACTOR), _defineProperty(_ref22, RESIDUAL, RESIDUAL), _defineProperty(_ref22, YEARLY_MILES, YEARLY_MILES), _defineProperty(_ref22, REBATE, REBATE), _defineProperty(_ref22, DUEBILLS, DUEBILLS), _defineProperty(_ref22, FNIMENU, FNIMENU), _defineProperty(_ref22, DAYS_TO_FIRSTPAYMENT, DAYS_TO_FIRSTPAYMENT), _defineProperty(_ref22, FEES, FEES), _defineProperty(_ref22, SECURITY_DEPOSIT, SECURITY_DEPOSIT), _defineProperty(_ref22, PAYMENT_FREQUENCY, PAYMENT_FREQUENCY), _defineProperty(_ref22, FINANCE_ADJUSTED_CAPITAL_COST, FINANCE_ADJUSTED_CAPITAL_COST), _defineProperty(_ref22, LOAN_TO_VALUE_RATIO, LOAN_TO_VALUE_RATIO), _defineProperty(_ref22, TAXES, TAXES), _defineProperty(_ref22, DRIVE_OFF, DRIVE_OFF), _defineProperty(_ref22, OUT_OF_POCKET_CASH, OUT_OF_POCKET_CASH), _defineProperty(_ref22, FINANCE_CHARGE, FINANCE_CHARGE), _ref22;
  }

  if (CATEGORY_2_DEAL_TYPES.includes(dealType)) {
    var _ref23;

    return _ref23 = {}, _defineProperty(_ref23, DUEBILLS, DUEBILLS), _defineProperty(_ref23, FNIMENU, FNIMENU), _defineProperty(_ref23, TAXES, TAXES), _defineProperty(_ref23, FEES, FEES), _ref23;
  }

  if (CATEGORY_4_DEAL_TYPES.includes(dealType)) {
    return EMPTY_OBJECT;
  }

  return _objectSpread(_objectSpread(_defineProperty({}, DUEBILLS, DUEBILLS), shouldIncludeFees && _defineProperty({}, FEES, FEES)), shouldIncludeTaxes && _defineProperty({}, TAXES, TAXES));
}
export function isCategory1Deal(deal) {
  var dealType = DealReader.getDealType(deal);
  return CATEGORY_1_DEAL_TYPES.includes(dealType);
}
export function isCategory2Deal(deal) {
  var dealType = DealReader.getDealType(deal);
  return CATEGORY_2_DEAL_TYPES.includes(dealType);
}
export function isCategory4Deal(deal) {
  var dealType = DealReader.getDealType(deal);
  return CATEGORY_4_DEAL_TYPES.includes(dealType);
}
export function isCategory3Deal(deal) {
  var dealType = DealReader.getDealType(deal);
  return CATEGORY_3_DEAL_TYPES.includes(dealType);
}
export function isSameDealCategory(currentdealType, newDealType) {
  if (CATEGORY_1_DEAL_TYPES.includes(currentdealType) && CATEGORY_1_DEAL_TYPES.includes(newDealType)) {
    return true;
  }

  if (CATEGORY_2_DEAL_TYPES.includes(currentdealType) && CATEGORY_2_DEAL_TYPES.includes(newDealType)) {
    return true;
  }

  if (CATEGORY_3_DEAL_TYPES.includes(currentdealType) && CATEGORY_3_DEAL_TYPES.includes(newDealType)) {
    return true;
  }

  if (CATEGORY_4_DEAL_TYPES.includes(currentdealType) && CATEGORY_4_DEAL_TYPES.includes(newDealType)) {
    return true;
  }

  return false;
}
export var getDeferredPayments = function getDeferredPayments(deskingPaymentDetails) {
  var deferredPayments = {};
  deskingPaymentDetails.forEach(function (columnData) {
    if (ColumnDataReader.isLoanOrBalloonPaymentType(columnData)) {
      var selectedTermPayment = ColumnDataReader.getTermPaymentInfoForSelectedLender(columnData) || EMPTY_OBJECT;
      Object.keys(selectedTermPayment).forEach(function (downPayment) {
        var program = _get(selectedTermPayment, [downPayment]) || EMPTY_OBJECT;
        var deferredPayment1 = program.deferredPayment1,
            deferredPayment2 = program.deferredPayment2,
            deferredPayment3 = program.deferredPayment3,
            deferredPayment4 = program.deferredPayment4;

        _setWith(deferredPayments, [downPayment], {
          deferredPayment1: deferredPayment1,
          deferredPayment2: deferredPayment2,
          deferredPayment3: deferredPayment3,
          deferredPayment4: deferredPayment4
        }, Object);
      });
    }
  });
  return deferredPayments;
};
export var getSelectedSellingPrice = function getSelectedSellingPrice(deal, selectedColumn) {
  var isMultipleDownPaymentEnabled = DealReader.isMultipleDownPaymentsEnabled(deal);
  if (!isMultipleDownPaymentEnabled || ColumnDataReader.isLoanOrCashOrBalloonPaymentType(selectedColumn)) return DealReader.getLoanSellingPriceOfPrimaryVehicle(deal);
  return DealReader.getLeaseSellingPriceOfPrimaryVehicle(deal);
};
export var getSellingPriceBasedOnVehicleId = function getSellingPriceBasedOnVehicleId(deal, selectedColumn, dealVehicleId) {
  var isMultipleDownPaymentEnabled = DealReader.isMultipleDownPaymentsEnabled(deal);

  if (!isMultipleDownPaymentEnabled || ColumnDataReader.isLoanOrCashOrBalloonPaymentType(selectedColumn)) {
    return DealReader.getLoanSellingPriceBasedOnVehicleId(deal, dealVehicleId);
  }

  return DealReader.getLeaseSellingPriceBasedOnVehicleId(deal, dealVehicleId);
};
export var getSellingPriceField = function getSellingPriceField(deal, column) {
  var isMultipleDownPaymentEnabled = DealReader.isMultipleDownPaymentsEnabled(deal);
  if (!isMultipleDownPaymentEnabled || ColumnDataReader.isLoanOrCashOrBalloonPaymentType(column)) return 'loanSellingPrice';
  return 'leaseSellingPrice';
};
export function isMarketScanFee(fee) {
  // return _get(fee, 'marketScan') || false;
  var source = _get(fee, 'source');

  return source === SOURCES_OF_FEES.MARKET_SCAN;
}
export var getCreditApplicationEnabledStatus = function getCreditApplicationEnabledStatus(creditIntegrations) {
  return _some(creditIntegrations, function (integrationEnabledStatus) {
    return integrationEnabledStatus === true;
  });
};
export function setFeeSource(fees, feeSource) {
  return fees.map(function (fee) {
    return _objectSpread(_objectSpread({}, fee), {}, {
      source: feeSource
    });
  });
}
export function removeUnwantedRebates(rebates) {
  return rebates.filter(function (rebate) {
    var programNumber = rebate.programNumber,
        programCode = rebate.programCode,
        rebateAmount = rebate.rebateAmount;

    if (programNumber || programCode || !_isNil(rebateAmount)) {
      return true;
    }

    return false;
  });
}
/**
 *
 * Deletes the params that are no longer applicable in a program upon changing any terms(like apr, residual, yearlyMiles)
 */

export function resetPaymentDataOnParamChange(program) {
  var resetProgram = _omit(program, ['amountFinanced', 'emiAmount', 'loanToValueRatio', 'baseEmiAmount']);

  _unset(resetProgram, ['taxes', 'taxRate']);

  _unset(resetProgram, ['taxes', 'tradeTaxExempt']);

  return resetProgram;
}
export function getUpfrontFees(fees) {
  var feeContents = [];
  var totalRegistrationFee = 0;
  fees.forEach(function (fee) {
    var upfront = _get(fee, 'upfront');

    var name = _get(fee, 'name') || 'NA';
    var amount = _get(fee, 'amount') || 0;

    if (upfront) {
      if (isFeeRegistrationFeeItem(fee)) {
        totalRegistrationFee = Money.add(totalRegistrationFee, Number(amount));
      } else {
        feeContents.push({
          name: name,
          price: Number(amount)
        });
      }
    }
  });
  feeContents.push({
    name: 'Registration Fee',
    price: totalRegistrationFee
  });
  return feeContents;
}
export function getUpfrontFNIs() {
  var fnis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var upfrontFNis = [];
  fnis.forEach(function (fni) {
    var displayName = fni.displayName,
        upfront = fni.upfront,
        price = fni.price;

    if (upfront) {
      upfrontFNis.push({
        name: displayName,
        price: price
      });
    }
  });
  return upfrontFNis;
}
export function getUpfrontAccessories() {
  var accessories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var upfrontAccessories = [];
  accessories.forEach(function (item) {
    var name = item.name,
        upfront = item.upfront,
        price = item.price;

    if (upfront) {
      upfrontAccessories.push({
        name: name,
        price: price
      });
    }
  });
  return upfrontAccessories;
}
export function isValueMoneyFactor(value) {
  return !!(Number(value) && Number(value) < APR_MF_DECIDER);
}

function isEmptyValue(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && _isEmpty(value)) return true;
  return false;
}

export function setAPRInAprData(newAPR, existingAPRData) {
  var isValueEmpty = isEmptyValue(newAPR);
  return produce(existingAPRData, function (draftState) {
    draftState.apr = newAPR;
    var markupForNewAPR = getNumber(newAPR) - getNumber(draftState.buyRate);

    if (markupForNewAPR <= 0 || _isEmpty(String(draftState.buyRate))) {
      if (isValueEmpty) {
        draftState.buyRateOverridden = false;
        draftState.buyRate = EMPTY_STRING;
      } else {
        draftState.markUp = EMPTY_STRING;
        draftState.markUpOverridden = false;
        draftState.buyRate = formatValueBasedOnRateType(newAPR, draftState.lenderRateType);
        draftState.buyRateOverridden = true;
      }
    } else {
      draftState.markUp = formatValueBasedOnRateType(markupForNewAPR, draftState.lenderRateType);
      draftState.markUpOverridden = true;
      var isMarkupBasedReserve = getNumber(draftState.reserveMethod) === RESERVE_METHOD.MARKUP_BASED;

      if (isMarkupBasedReserve) {
        draftState.financeReserve = 0;
        draftState.financeReserveOverridden = false;
      }
    }
  });
}
export function getFinalCashDeficiencyForDownpaymentId(columnData, downPaymentId, collectSalesTaxUpfront) {
  var cashDef = getNumber(ColumnDataReader.getCashDeficiencyForDownpaymentId(columnData, downPaymentId));
  var term = getNumber(ColumnDataReader.getTerm(columnData));
  var aprData = ColumnDataReader.getAPRData(columnData);
  var sellRate = getNumber(_get(aprData, 'apr') || 0);
  var taxRate = getNumber(ColumnDataReader.getTaxRate(columnData));
  var previousWeOweAmount = getCashDeficiencyAccessoryAmount(ColumnDataReader.getColumnAccessories(columnData));
  var moneyFactor = sellRate > APR_MF_DECIDER ? sellRate / RATE_TYPE_FACTOR : sellRate;
  var accessoryValue = 0;

  if (collectSalesTaxUpfront) {
    /*
    adjustments = oldWeOweAmount * ( ( (1 / term) + moneyFactor) * (1 + (taxRate * (term / 100))) );
    value = (cashDef - adjustments) / (1 - (1 / Term + Money Factor) * ( 1 + Tax Rate * Term / 100 ))
    */
    var adjustments = previousWeOweAmount * ((1 / term + moneyFactor) * (1 + taxRate / 100 * term));
    accessoryValue = (cashDef - adjustments) / (1 - (1 / term + moneyFactor) * (1 + taxRate * (term / 100)));
  } else {
    var _adjustments = previousWeOweAmount * ((1 / term + moneyFactor) * (1 + taxRate / 100));

    accessoryValue = (cashDef - _adjustments) * (term / (term - (1 + term * moneyFactor) * (1 + taxRate / 100)));
  }

  return accessoryValue;
}
export var anyColumnHasCashDeficiency = function anyColumnHasCashDeficiency(_ref26) {
  var deskingPaymentDetails = _ref26.deskingPaymentDetails,
      columnIds = _ref26.columnIds,
      downPaymentIds = _ref26.downPaymentIds;
  return !!columnIds.some(function (columnId) {
    var currentColumn = ColumnDataReader.getColumnDataById(deskingPaymentDetails, columnId);
    return downPaymentIds.some(function (downPaymentId) {
      var cashDef = getNumber(ColumnDataReader.getCashDeficiencyForDownpaymentId(currentColumn, downPaymentId));
      return cashDef !== 0;
    });
  });
};
export var getDownpaymentIdWithGreatestCashDeficiency = function getDownpaymentIdWithGreatestCashDeficiency(_ref27) {
  var deskingPaymentDetails = _ref27.deskingPaymentDetails,
      columnIds = _ref27.columnIds,
      downPaymentIds = _ref27.downPaymentIds;

  var _loop = function _loop(columnIndex) {
    var currentColumn = ColumnDataReader.getColumnDataById(deskingPaymentDetails, columnIds[columnIndex]);
    var highestCashDeficiency = 0;
    var downPaymentIdWithHighestCashDeficiency = void 0;
    downPaymentIds.forEach(function (downPaymentId) {
      var cashDef = getNumber(ColumnDataReader.getCashDeficiencyForDownpaymentId(currentColumn, downPaymentId));

      if (cashDef > highestCashDeficiency) {
        highestCashDeficiency = cashDef;
        downPaymentIdWithHighestCashDeficiency = downPaymentId;
      }
    });

    if (highestCashDeficiency > 0 && !_isNil(downPaymentIdWithHighestCashDeficiency)) {
      return {
        v: downPaymentIdWithHighestCashDeficiency
      };
    }
  };

  for (var columnIndex = 0; columnIndex < columnIds.length; columnIndex += 1) {
    var _ret = _loop(columnIndex);

    if (_typeof(_ret) === "object") return _ret.v;
  }

  return null;
};
export var getDefaultStateFeeTaxOptions = function getDefaultStateFeeTaxOptions(marketId) {
  var feeAndTaxConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  return _merge({}, getLocalDefaultStateFeeTaxOptions(marketId), feeAndTaxConfig);
};
export var getFNIsToBeSentINMSPayload = function getFNIsToBeSentINMSPayload(columnData) {
  var columnsFNIsOriginal = ColumnDataReader.getColumnFNIs(columnData);
  var columnsFNIs = columnsFNIsOriginal.map(function (fni) {
    return _objectSpread(_objectSpread({}, fni), {}, {
      TaxedAsAftermarketProduct: !!fni.taxable
    });
  });
  return columnsFNIs;
};
export function shouldSetTaxExemptUseTax(marketId, paymentType) {
  var isCaliforniaMarket = [MSStates.CA, MSStates.SA, MSStates.SI].includes(STATE_BY_MARKET_IDS[marketId]);
  return isCaliforniaMarket && isLeasePaymentType(paymentType);
}
export var disableSelectedPaymentOption = defaultMemoize(function (selectedPaymentOption) {
  return PAYMENT_MODES.map(function (pmode) {
    if (pmode.value === selectedPaymentOption) return _objectSpread(_objectSpread({}, pmode), {}, {
      disabled: true
    });
    return pmode;
  });
});
/**
 * pdfLoaders: Object
 * keysToPick: Array
 */

export var getPdfLoader = defaultMemoize(function (pdfLoaders, keysToPick) {
  return pdfLoaders && !_isEmpty(_compact(_map(_castArray(keysToPick), function (key) {
    return pdfLoaders[key];
  })));
});
export var getCostAdjustmentIndexByType = function getCostAdjustmentIndexByType(deal, type) {
  var costAdjustments = DealReader.getCostAdjustmentsOfPrimaryVehicle(deal) || [];
  return costAdjustments.findIndex(function (_ref28) {
    var description = _ref28.description,
        userId = _ref28.userId;
    return description === type && isCreatedBySystem(userId);
  });
};
export var isVinLookUpResloved = function isVinLookUpResloved(trimStatus) {
  return trimStatus === VIN_LOOKUP.SUCCESS;
};
export var getDealDiscount = function getDealDiscount(deal, columnData) {
  var pricingDetails = DealReader.getPricingDataOfPrimaryVehicle(deal);
  var dealSellingPrice = getSelectedSellingPrice(deal, columnData);
  var msrp = pricingDetails.msrp,
      retailPrice = pricingDetails.retailPrice;
  var valueToBeSubtractedFrom = msrp || retailPrice || 0;
  return getNumber(Money.subtract(valueToBeSubtractedFrom, dealSellingPrice));
};
export var getInitialRebateFilters = function getInitialRebateFilters() {
  return {
    includeExpired: false,
    paymentType: [DEFAULT_PAYMENT_TYPE_FILTER],
    vehicleRebateRegions: [],
    regionId: DEFAULT_REGION_ID,
    dontApplyFirstPaymentWaiver: false
  };
};
export var isDealBooked = function isDealBooked(dealStatus) {
  return DEAL_STATUS_WEIGHTS[dealStatus] >= DEAL_STATUS_WEIGHTS[DEAL_STATUS.BOOKED];
};
export var getLeaseorOnePayColumnIds = function getLeaseorOnePayColumnIds(deskingpaymentDetails) {
  var leaseColumns = deskingpaymentDetails.filter(function (column) {
    return ColumnDataReader.isLeaseOrOPLeasePaymentType(column);
  });
  var leaseColumnIds = leaseColumns.map(function (_ref29) {
    var id = _ref29.id;
    return id;
  });
  return leaseColumnIds;
};
export var isLoanOrCashOrBalloonPaymentType = function isLoanOrCashOrBalloonPaymentType(deskingpaymentDetails) {
  var retailColumns = deskingpaymentDetails.filter(function (column) {
    return ColumnDataReader.isLoanOrCashOrBalloonPaymentType(column);
  });
  var retailColumnIds = retailColumns.map(function (_ref30) {
    var id = _ref30.id;
    return id;
  });
  return retailColumnIds;
};
export var getColumnIdsWrtPaymentTypeOfColumn = function getColumnIdsWrtPaymentTypeOfColumn(column, deskingpaymentDetails) {
  var isLeaseType = ColumnDataReader.isLeaseOrOPLeasePaymentType(column);
  if (isLeaseType) return getLeaseorOnePayColumnIds(deskingpaymentDetails);
  return isLoanOrCashOrBalloonPaymentType(deskingpaymentDetails);
};
export var getSubStatusOptionsForFlagPicker = defaultMemoize(function (dealSubStatusList) {
  return _map(_filter(dealSubStatusList, function (_ref31) {
    var enabled = _ref31.enabled;
    return enabled;
  }), function (_ref32) {
    var status = _ref32.status,
        flag = _ref32.flag,
        enabled = _ref32.enabled;
    return {
      label: status,
      value: status,
      flagColor: flag,
      enabled: enabled
    };
  });
});
export var joinFormKeys = function joinFormKeys() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return _join(_map(data, function (_ref33) {
    var formKey = _ref33.formKey,
        formName = _ref33.formName;
    return formName || formKey;
  }), ', ');
}; // https://tekion.atlassian.net/browse/DMS-18176

export var getResidualDifference = function getResidualDifference(_ref34) {
  var columns = _ref34.columns,
      mScanResponse = _ref34.mScanResponse,
      deal = _ref34.deal,
      downPayments = _ref34.downPayments;
  var residualDiffData = {};
  var isMultipleDownPaymentsFlagEnabled = DealReader.isMultipleDownPaymentsEnabled(deal);

  var marketScanData = _get(mScanResponse, ['marketScanData']);

  _forEach(columns, function (column) {
    var columnId = column.id;

    if (ColumnDataReader.isLeaseOrOPLeaseOrBalloonPaymentType(column)) {
      var paymentType = ColumnDataReader.getPaymentType(column);
      var existingDownPaymentsForColumn = getDownPaymentsForPaymentType(downPayments, paymentType, isMultipleDownPaymentsFlagEnabled);

      var programOF = _get(marketScanData, [columnId]);

      _forEach(existingDownPaymentsForColumn, function (dpValue, existingDownPaymentId) {
        _forEach(programOF, function (details, downpaymnet) {
          if (Number(downpaymnet) === dpValue) {
            var newResidualAdjustmentPct = _get(details, ['FullDetails', 'Lease', 'ResidualValueMileageAdjustmentPct']);

            var newResidualAdjustmentValue = _get(details, ['FullDetails', 'Lease', 'ResidualValueMileageAdjustment']);

            var currentadjustedPct = ColumnDataReader.residuaAdjustedPercentage(column, existingDownPaymentId);
            var currentAdjustedValue = ColumnDataReader.residuaAdjustedValue(column, existingDownPaymentId);

            if ((newResidualAdjustmentPct || newResidualAdjustmentValue) && (!currentadjustedPct || !currentAdjustedValue)) {
              _set(residualDiffData, [columnId, existingDownPaymentId], {
                pctDiff: newResidualAdjustmentPct,
                valueDiff: newResidualAdjustmentValue
              });
            }
          }
        });
      });
    }
  });

  return residualDiffData;
};
export var getUpdatedTaxAndZipCodeDetails = function getUpdatedTaxAndZipCodeDetails(draft, payload) {
  var _ref35 = payload || EMPTY_OBJECT,
      key = _ref35.key,
      value = _ref35.value,
      mergeData = _ref35.mergeData,
      type = _ref35.type,
      replaceData = _ref35.replaceData;

  var taxAndZipCodeDetails = _get(draft, 'deal.data.taxAndZipCodeDetails') || {};

  if (replaceData) {
    return replaceData;
  }

  if (key) {
    if (type) _set(taxAndZipCodeDetails, _concat(type, _split(key, '.')), value);else {
      _set(taxAndZipCodeDetails, [TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE].concat(_toConsumableArray(_split(key, '.'))), value);

      _set(taxAndZipCodeDetails, [TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL].concat(_toConsumableArray(_split(key, '.'))), value);
    }
  } else if (mergeData) {
    if (type) _merge(taxAndZipCodeDetails[type], mergeData);else {
      _merge(taxAndZipCodeDetails[TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE], mergeData);

      _merge(taxAndZipCodeDetails[TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL], mergeData);
    }
  } else if (type) {
    _set(taxAndZipCodeDetails, type, value);
  } else {
    _set(taxAndZipCodeDetails, TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE, value);

    _set(taxAndZipCodeDetails, TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL, value);
  }

  return taxAndZipCodeDetails;
};

var mergeStateFeeTaxOptions = function mergeStateFeeTaxOptions(options) {
  return function (existingOptions) {
    return _objectSpread(_objectSpread({}, existingOptions), options);
  };
};

export var getUpdatedStateFeeTaxOptions = function getUpdatedStateFeeTaxOptions(draft, payload) {
  var options = payload.options,
      type = payload.type;
  var stateFeeTaxOptions = _get(draft, 'deal.data.stateFeeTaxOptions') || {};
  var mergeWithNewStateFeeTaxOptions = mergeStateFeeTaxOptions(options);

  if (type) {
    stateFeeTaxOptions[type] = mergeWithNewStateFeeTaxOptions(_get(stateFeeTaxOptions, type));
  } else {
    stateFeeTaxOptions[TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE] = mergeWithNewStateFeeTaxOptions(_get(stateFeeTaxOptions, TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE));
    stateFeeTaxOptions[TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL] = mergeWithNewStateFeeTaxOptions(_get(stateFeeTaxOptions, TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL));
  }

  return stateFeeTaxOptions;
};
export function getColumnForGivenTaxType(deskingpaymentDetails, taxType) {
  var columnsOfGivenTaxType = deskingpaymentDetails.filter(function (cd) {
    return PAYMENT_TYPE_VS_TAX_TYPE[ColumnDataReader.getPaymentType(cd)] === taxType;
  }) || [];
  var selectedColumn = ColumnDataReader.getSelectedColumn(columnsOfGivenTaxType);
  return _isEmpty(selectedColumn) ? _head(columnsOfGivenTaxType) || EMPTY_OBJECT : selectedColumn;
}
export var getSelectedSiteName = function getSelectedSiteName(oemSites, siteId) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  return _get(findArrayItem(oemSites, key, siteId), 'label');
};
export var getDefaultLenderFromSetup = function getDefaultLenderFromSetup(lenderConfig, columnPaymentType, deal) {
  var buyer = DealReader.getBuyer(deal);

  var _getCustomerAddressDe = getCustomerAddressDetails(buyer),
      state = _getCustomerAddressDe.state;

  var argsList = {
    vehicle: DealReader.getPrimaryVehicle(deal),
    siteId: DealReader.getDealCreatedAtSite(deal),
    customerState: state,
    columnPaymentType: columnPaymentType
  };
  var lenderCodesRequired = [];
  lenderConfig.forEach(function (lender) {
    var lenderIds = _get(lender, 'lenderIds') || EMPTY_ARRAY;
    var targetingParams = _get(lender, 'targetingParams') || EMPTY_ARRAY;
    var lenderSupported = targetingParams.reduce(function (status, param) {
      var attribute = param.attribute,
          values = param.values;
      var validator = lenderRulesvalidatorFunction[attribute] || _noop;
      var validatorFunctionArguments = lenderRulesValidatorParams[attribute] || [];

      var paramsRequired = _pick(argsList, validatorFunctionArguments);

      var isFeeSupported = validator({
        status: status,
        targetingParams: targetingParams,
        values: values,
        paramsRequired: paramsRequired
      });
      return isFeeSupported && status;
    }, true);

    if (lenderSupported) {
      lenderCodesRequired.push(lenderIds);
    }
  });
  return _flattenDeep(lenderCodesRequired);
};
export function getAccessoriesToBeIncludedInSellingPrice(salesSetupInfo, columnData) {
  if (String(getDealerMarketId(salesSetupInfo)) === String(MSStateID.TX)) {
    return ColumnDataReader.getTaxableAccessoriesOfDisclosureTypeOther(columnData);
  }

  return [];
}
export function getAddressForZipCodeDetailsFromBuyer(buyer, showLocationInZipCodeScreen) {
  var buyerMarketId = getMarketId(buyer);

  if (!showLocationInZipCodeScreen.includes(_toNumber(buyerMarketId))) {
    return {};
  }

  var address = getAddressOfBuyerInDeal(buyer) || {};
  var zipCodeAddress = _pick(address, ['address1', 'city', 'state', 'country']) || {};
  var latitudeAndLongitude = _pick(address, ['latitudeAndLongitude.latitude', 'latitudeAndLongitude.longitude']) || {};
  var address1 = "".concat(_get(address, 'address1') || '', ", ").concat(_get(address, 'city') || '', ", ").concat(_get(address, 'state') || '', " ").concat(_get(address, 'zipCode') || '');
  return _objectSpread(_objectSpread(_objectSpread({}, zipCodeAddress), latitudeAndLongitude), {}, {
    address1: address1
  });
}
export function isAddressChanged(oldbuyer, newBuyer, showLocationInZipCodeScreen) {
  var buyerMarketId = getMarketId(newBuyer);

  if (!showLocationInZipCodeScreen.includes(_toNumber(buyerMarketId))) {
    return false;
  }

  var oldAddress = getAddressOfBuyerInDeal(oldbuyer) || {};
  var newAddress = getAddressOfBuyerInDeal(newBuyer) || {};

  var oldAddresskeys = _pick(oldAddress, ['address1', 'latitudeAndLongitude.longitude', 'latitudeAndLongitude.latitude']);

  var newAddresskeys = _pick(newAddress, ['address1', 'latitudeAndLongitude.longitude', 'latitudeAndLongitude.latitude']);

  return !_isEqual(oldAddresskeys, newAddresskeys);
}
export var getPrimaryVehicleSpecificColumns = function getPrimaryVehicleSpecificColumns(primaryDealVehicleId, deskingPaymentDetails) {
  return _filter(deskingPaymentDetails, function (_ref36) {
    var dealVehicleId = _ref36.dealVehicleId;
    return dealVehicleId === primaryDealVehicleId;
  });
};
export var getDefaultDownpaymentToSelect = function getDefaultDownpaymentToSelect(deskingPaymentDetails, deal) {
  var dealVehicleId = DealReader.getPrimaryVehicleDealVehicleId(deal);
  var columnData = deskingPaymentDetails.find(function (_ref37) {
    var id = _ref37.dealVehicleId;
    return id === dealVehicleId;
  }) || {};
  var selectedLenderId = columnData.selectedLenderId,
      termPaymentDetails = columnData.termPaymentDetails;

  var _ref38 = _get(termPaymentDetails, [selectedLenderId, '0']) || EMPTY_OBJECT,
      downPaymentIndex = _ref38.downPaymentIndex,
      downPayment = _ref38.downPayment;

  var selectedColumnId = _get(columnData, 'id');

  return {
    payload: {
      id: selectedColumnId,
      downPaymentId: downPaymentIndex || 0,
      downPaymentValue: downPayment
    },
    columnData: columnData
  };
};
export var getAddress = function getAddress(city, province, county, state, zipCode) {
  var concatenatedAddress = [];
  if (city) concatenatedAddress.push(city);
  if (province) concatenatedAddress.push(province);
  if (county) concatenatedAddress.push(county);
  if (state) concatenatedAddress.push(state);
  if (zipCode) concatenatedAddress.push(zipCode);
  return _join(concatenatedAddress, ', ');
};
export var commaSeparatedAddressToArray = function commaSeparatedAddressToArray(address) {
  return _split(address, ',');
};
export var renderAddress = function renderAddress(addresses, city, province, county, state, zipCode) {
  return city || province || county || zipCode || state ? getAddress(city, province, county, state, zipCode) : _join(_slice(addresses, 2), ',');
};
export var DEAL_STATUS_VS_CONDITION_TO_SHOW = function DEAL_STATUS_VS_CONDITION_TO_SHOW(salesSetupInfo) {
  var _ref39;

  return _ref39 = {}, _defineProperty(_ref39, DEAL_STATUS.QUOTE, true), _defineProperty(_ref39, DEAL_STATUS.FINANCE_AND_INSURANCE, true), _defineProperty(_ref39, DEAL_STATUS.RECAP, true), _defineProperty(_ref39, DEAL_STATUS.DOCS_SIGNING, true), _defineProperty(_ref39, DEAL_STATUS.DOCS_PRINTED, true), _defineProperty(_ref39, DEAL_STATUS.BOOKED, true), _defineProperty(_ref39, DEAL_STATUS.LOST, true), _defineProperty(_ref39, DEAL_STATUS.CREDIT_APPROVED, true), _defineProperty(_ref39, DEAL_STATUS.CLOSED_OR_SOLD, true), _defineProperty(_ref39, DEAL_STATUS.UNWIND, true), _defineProperty(_ref39, DEAL_STATUS.PREORDER, true), _defineProperty(_ref39, DEAL_STATUS.PRE_CLOSED, isPrecloseFlowEnabled(salesSetupInfo)), _defineProperty(_ref39, DEAL_STATUS.CONFIRMED, true), _ref39;
};

var calcRegFee = function calcRegFee(deal, defaultValue) {
  return function (value) {
    return DealReader.getOverrideFees(deal) ? defaultValue : value;
  };
};

export var MS_STATE_FEE_TAX_KEY_VS_VALUE = function MS_STATE_FEE_TAX_KEY_VS_VALUE(deal) {
  return {
    WaiveRegistrationFee: calcRegFee(deal, true),
    CalculateRegistrationFee: calcRegFee(deal, false)
  };
};
export var getSecDepValForDropdown = function getSecDepValForDropdown(securityDepositType, securityDeposit) {
  var securityDepositNum = getNumber(securityDeposit);
  return securityDepositType ? "".concat(securityDepositNum, "(").concat(DEPOSIT_TYPE_VS_LABEL[securityDepositType], ")") : securityDepositNum;
};
export var getSecurityDepositOptions = defaultMemoize(function (securityDeposits) {
  if (_isEmpty(securityDeposits)) return DEFAULT_SECURITY_DEPOSIT_OPTION;
  return _map(securityDeposits.sort(function (_ref40, _ref41) {
    var amount1 = _ref40.amount;
    var amount2 = _ref41.amount;
    return amount1 - amount2;
  }), function (_ref42) {
    var amount = _ref42.amount,
        type = _ref42.type;
    var label = getSecDepValForDropdown(type, amount);
    return {
      value: label,
      label: label,
      amount: amount
    };
  });
});
export var findSecurityDepopsitByAmountAndType = function findSecurityDepopsitByAmountAndType(securityDeposits, securityDepositAmount, securityDepositType) {
  return _find(securityDeposits, function (_ref43) {
    var amount = _ref43.amount,
        type = _ref43.type;
    var amountMatches = amount && securityDepositAmount && getNumber(amount) === getNumber(securityDepositAmount);
    var typeMatches = type && securityDepositType && type === securityDepositType;
    return amountMatches && typeMatches;
  });
};
export var getCalculatedFeeValues = function getCalculatedFeeValues() {
  var fees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var deal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var primaryVehicle = DealReader.getPrimaryVehicle(deal) || EMPTY_OBJECT;
  var _primaryVehicle$newTy = primaryVehicle.newTyreCount,
      newTyreCount = _primaryVehicle$newTy === void 0 ? 0 : _primaryVehicle$newTy;
  return fees.map(function (fee) {
    var internalFeeCode = fee.internalFeeCode,
        _fee$baseAmount = fee.baseAmount,
        baseAmount = _fee$baseAmount === void 0 ? 0 : _fee$baseAmount,
        pricingType = fee.pricingType;

    if (internalFeeCode === INTERNAL_FEE_CODES.TIRE_FEE && pricingType === 'CALCULATED_PRICE') {
      return _objectSpread(_objectSpread({}, fee), {}, {
        amount: baseAmount / 100 * newTyreCount
      });
    }

    return fee;
  });
};
export var shouldRemoveCustomRebates = function shouldRemoveCustomRebates(oldPrimaryVehicleType, newPrimaryVehicleType) {
  return oldPrimaryVehicleType === VEHICLE_TYPE.USED && newPrimaryVehicleType === VEHICLE_TYPE.NEW || newPrimaryVehicleType === VEHICLE_TYPE.USED && oldPrimaryVehicleType === VEHICLE_TYPE.NEW;
};
export var getMarketIdForFNITaxCalculation = function getMarketIdForFNITaxCalculation(deal, columnData) {
  var buyer = DealReader.getBuyer(deal) || EMPTY_OBJECT;
  var buyerMarketId = getMarketId(buyer);
  var leaseMarketId = DealReader.getMarketId(deal, TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE);
  var retailMarketId = DealReader.getMarketId(deal, TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL);
  var paymentType = ColumnDataReader.getPaymentType(columnData);
  return buyerMarketId || (paymentType === PAYMENT_TYPES.LEASE ? leaseMarketId : retailMarketId);
};